/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ActivationStatus } from './activationStatus';
import { ChannelType } from './channelType';
import { ServiceBillingMode } from './serviceBillingMode';
import { ServiceCreationStatus } from './serviceCreationStatus';
import { SubscriptionType } from './subscriptionType';
import { VasServiceResonseModel } from './vasServiceResonseModel';

export interface VasResponseData { 
    id?: string;
    runTime?: number;
    keyword?: string;
    unsubscriptionKeyword?: string;
    shortCodeKeyNumber?: string;
    serviceName?: string;
    serviceDescription?: string;
    serviceBillingMode?: ServiceBillingMode;
    serviceFee?: number;
    category?: string;
    channel?: ChannelType;
    shortCode?: string;
    subcriptionType?: SubscriptionType;
    frequency?: number;
    activeDate?: Date;
    expiryDate?: Date;
    dateCreated?: Date;
    status?: ServiceCreationStatus;
    serviceProviderId?: string;
    industryId?: string;
    ussdCampaignId?: string;
    tenantId?: string;
    isCallback?: boolean;
    activationStatus?: ActivationStatus;
    callbackUrl?: string;
    serviceResponse?: VasServiceResonseModel;
}